import React from "react";
import data from "../../data";
import "./skills.css";
const Skills = () => {
  return (
    <div className="skills">
      <h2> مهاراتي</h2>
      <ul className="skill">
        {data.map((skill) => {
          return (
            <li key={skill.id}>
              <h3>{skill.skill}</h3>
              <img src={skill.img} alt={skill.skill} />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Skills;
